import { useMemo } from 'react'
import { projectDataSelectors } from 'store/features/projectData/selectors'
import { findVideoItemOverlappingWithPlayhead } from 'store/features/projectData/thunks/utils'
import { useSelector } from 'react-redux'
import { useGetCurrentPlayheadTime } from 'hooks/timeline'
import { sortArraysByKey } from 'store/features/projectData/utils'
export const useGetOverlappingVideoItem = () => {
  const mediaItems = useSelector(projectDataSelectors.mediaItems)

  const sortedMediaItems = useMemo(() => {
    return sortArraysByKey('startTime', mediaItems)
  }, [mediaItems])

  const playHeadTime = useGetCurrentPlayheadTime()

  const overlappingVideoItem = useMemo(
    () => findVideoItemOverlappingWithPlayhead(mediaItems, playHeadTime),
    [mediaItems, playHeadTime]
  )

  const overlappingVideoIndex = useMemo(() => {
    return sortedMediaItems.findIndex(
      item => item.id === overlappingVideoItem?.id
    )
  }, [sortedMediaItems, overlappingVideoItem])

  return { overlappingVideoItem, overlappingVideoIndex }
}
